export enum DocumentEnum {
  AADHAAR = 'AADHAAR',
  PAN = 'PAN',
  VOTER_ID = 'VOTER_ID',
  PASSPORT = 'PASSPORT',
  ADDRESS_PROOF = 'ADDRESS_PROOF',
  OTHER = 'OTHER',
  PROFILE_PICTURE = 'PROFILE_PICTURE',
  CERTIFICATE = 'CERTIFICATE',
  EDUCATIONAL_DOCUMENT = 'EDUCATIONAL_DOCUMENT',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  ISSUE='ISSUE'
}
